import Link from 'next/link';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import { Box } from 'rebass/styled-components';
import styled from 'styled-components';

import Text from '@/components/Text';
import { useBreakpoints } from '@/hooks';
import Footermenu from '@/widgets/Navigation/Footermenu';

const FooterListWarapper = styled(Box)`
  display: block;
  width: 100%;
  text-align: center;
  margin: ${(props) => (props.mobile ? '20px 0 50px;' : '0;')};
`;

const Dotsbetween = styled('ul')`
  display: inline-block;
  padding: 0;
  text-align: center;
`;
const DotsbetweenItem = styled('li')`
  font-size: 12px;
  display: inline;
  margin: 0;
  white-space: initial;
  &:after {
    content: ' ';
    letter-spacing: 2.5em;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADBAMAAACkBqiMAAAAElBMVEVZWFhZV1dYWFhQUFBHcExZV1daIsBvAAAABnRSTlPg0CAQAPDwvp0YAAAAEUlEQVQI12MQMGBgNWAwcgAAA1YA6EwhhUAAAAAASUVORK5CYII=)
      center center no-repeat;
  }
  &:before {
    display: none;
  }
  @media (min-width: 1480px) {
    &:after {
      content: ' ';
      letter-spacing: 2.5em;
      background: none;
    }
  }
  @media (max-width: 469px) {
    display: flex;
    flex-direction: column;
  }
`;

const SpecialFooter = ({ isKampagne }) => {
  const width = useRef(null);
  const breakpoint = useBreakpoints();
  const isMobile = ['small'].includes(breakpoint);

  return (
    <FooterListWarapper
      style={isKampagne ? { background: '#F7F7F7', paddingTop: '2px' } : null}
      ref={width}
      mobile={isMobile && !isKampagne}
    >
      <Dotsbetween style={isKampagne || !isMobile ? { marginBottom: '0' } : { marginBottom: '30px' }}>
        {isKampagne || !isMobile ? (
          <>
            {Footermenu().nav.map((item) => (
              <DotsbetweenItem>
                {item.url ? (
                  <Link href={item.url ?? '/'} key={item.title}>
                    <a data-testid={item.title} title={item.title}>
                      <Text variant="navFooterLinkSpecial">{item.title}</Text>
                    </a>
                  </Link>
                ) : (
                  <Text variant="navFooterLinkSpecial" sx={{ cursor: 'default' }}>
                    {item.title}
                  </Text>
                )}
              </DotsbetweenItem>
            ))}
          </>
        ) : (
          <>
            {Footermenu().nav.map((item) => (
              <DotsbetweenItem>
                {item.url ? (
                  <Link href={item.url ?? '/'} key={item.title}>
                    <a data-testid={item.title} title={item.title}>
                      <Text variant="navFooterLinkSpecial">{item.title}</Text>
                    </a>
                  </Link>
                ) : null}
              </DotsbetweenItem>
            ))}
          </>
        )}
      </Dotsbetween>
    </FooterListWarapper>
  );
};

SpecialFooter.propTypes = {
  isKampagne: PropTypes.bool,
};

SpecialFooter.defaultProps = {
  isKampagne: undefined,
};

export default SpecialFooter;
